export const getDragAndDropStyles = ({ active, disabled, error }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  padding: '40px',
  border: ({ palette }) => `1px dashed ${palette.border.input}`,
  borderRadius: '8px',
  cursor: 'pointer',
  transition: ({ transition }) => transition.default,
  ...(active && {
    border: ({ palette }) => `1px dashed ${palette.primary.main}`,
    backgroundColor: ({ palette }) => palette.primary.extraSoft,
  }),
  ...(error && {
    border: ({ palette }) => `1px dashed ${palette.error.dark}`,
    backgroundColor: ({ palette }) => palette.error.extraSoft,
  }),
  ...(disabled && {
    backgroundColor: ({ palette }) => palette.background.secondary,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  }),
  '& svg': {
    color: ({ palette }) => {
      const defaultColor = disabled
        ? (palette.icon?.disabled ?? palette.text.disabled)
        : palette.primary.main;

      return error ? palette.error.dark : defaultColor;
    },
  },
  '& .MuiLink-root': {
    color: ({ palette }) => (disabled ? palette.primary.light : palette.primary.main),
  },
});

export const previewStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '16px',
  border: ({ palette }) => `1px dashed ${palette.border.input}`,
  borderRadius: '8px',
};

export const previewImageStyles = { maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' };

export const loaderStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1,
};

export const uploadedIconStyles = {
  color: ({ palette }) => palette.primary.main,
};

export const infoMessageStyles = { padding: '12px' };

export const dragDropStyles = {
  position: 'relative',
  marginTop: '8px',

  '& input': {
    display: 'none',
  },
};
